import StyledField from 'common/TextField/TexField1';
import { Button, Grid } from '@mui/material';
import Filter from "common/Select/SelectMultiFilter";
import { useTranslation } from 'react-i18next';
import { themes } from 'theme/themes';
import { brandingInfo } from 'features/server/brandingSlice';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import DateRangePicker from 'common/Pickers/DateRangePicker';

interface PaymentSearchHeaderComponentProps {
  handleChangeFilter: (event: any) => void;
  handleChangeSearch: (field: string, value: any) => void;
  handleSubmitSearch: () => void;
  searchFormData: any;
  filter: string[];
  clearSearch: () => void;
  search: any;
}

const PaymentSearchHeader: React.FC<PaymentSearchHeaderComponentProps> = ({
  handleChangeFilter,
  handleChangeSearch,
  handleSubmitSearch,
  searchFormData,
  filter,
  clearSearch,
  search
}) => {
  const { t } = useTranslation();
  const branding = useSelector(brandingInfo);
  const themeColors = branding?.attributes?.themeId === 100 ? branding?.attributes?.customTheme : (themes as any)[branding?.attributes?.themeId || 3];
  const filterOptions = ['paymentNo', 'clientName', 'dateInterval'];
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSubmitSearch();
    }
  };
  
  return (
    <>
      <Grid container spacing={1} alignItems="flex-start">
        <Grid item xs={12} sm={6} md={3}>
          <Filter 
            label="Filter By"
            filterOptions={filterOptions}
            handleChangeFilter={handleChangeFilter}
            filter={filter}
          />
        </Grid>
        {filter.map((fieldName) => (
          fieldName === 'dateInterval' ? <Grid item key={fieldName} xs={12} sm={6} md={3} className='max-w-[fit-content]'>
              <DateRangePicker
                label=''
                maxDate={dayjs()}
                placeholder={'YYYY-MM-DD → YYYY-MM-DD'}
                onChange={(value) =>
                  handleChangeSearch('dateInterval', [value?.[0] ? value[0].format('YYYY-MM-DD') : null, value?.[1] ? value[1].format('YYYY-MM-DD') : null,])
                }
                value={[
                  searchFormData?.start ? dayjs(searchFormData.start) : null,
                  searchFormData?.end ? dayjs(searchFormData.end) : null,
                ]}
              />
            </Grid>
          : <Grid item key={fieldName} xs={12} sm={6} md={3}>
              <StyledField
                fullWidth={true}
                placeholder={t(fieldName)}
                displayPlaceholder={true}
                handleChange={(e) => handleChangeSearch(fieldName, e.target.value)}
                required={true}
                value={searchFormData?.[fieldName] || ''}
                handleKeyDown={handleKeyPress}
              />
          </Grid>
        ))}
        <Grid item xs={12} sm={6} md={2} sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
          <Button 
            variant="contained"
            disabled={filter.length ? false : true}
            onClick={handleSubmitSearch}
            sx={{
              boxShadow: 'none',
              background: filter.length > 0 ? themeColors?.primary : '#B8C0C6',
              height: 38,
              minHeight: 38,
            }}
            className={`text-white text-ellipsis overflow-hidden font-Saira font-[600] text-[13px] px-8 py-1`}
          >{t('submit')}</Button>
          {filter.length && Object.keys(search).length || filter.length > 1 ?
            <Button 
            variant="contained"
            onClick={clearSearch}
            sx={{
              boxShadow: 'none',
              color: themeColors?.primary,
              height: 38,
              minHeight: 38,
            }}
            className={`text-ellipsis overflow-hidden font-Saira font-[600] text-[13px] bg-[#d8d1e0] px-8 py-1`}
          >{t('clear')}</Button>: null}
        </Grid>
      </Grid>
    </>
  );
};

export default PaymentSearchHeader;